// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-bmskp{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-dhnzr{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-vecwj{grid-column:span 6}.assets-scss-gridstyleGrid-col3-bxaks{grid-column:span 3}.assets-scss-gridstyleGrid-col4-soogf{grid-column:span 4}.assets-scss-gridstyleGrid-col9-cbsfg{grid-column:span 9}.assets-scss-gridstyleGrid-col12-ssqbz{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-jflze{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-bmskp",
	"grid": "assets-scss-gridstyleGrid-grid-dhnzr",
	"col6": "assets-scss-gridstyleGrid-col6-vecwj",
	"col3": "assets-scss-gridstyleGrid-col3-bxaks",
	"col4": "assets-scss-gridstyleGrid-col4-soogf",
	"col9": "assets-scss-gridstyleGrid-col9-cbsfg",
	"col12": "assets-scss-gridstyleGrid-col12-ssqbz",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-jflze"
};
module.exports = ___CSS_LOADER_EXPORT___;
